import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const HitText = styled(Box)`
  color: #727272;
  font-size: 13px;
`;
